import React from 'react';
import loadingIcon from '../assets/images/loading.gif';

const Loader:React.FunctionComponent<{}> = () => (
    <img className='loader__icon' src={loadingIcon} alt='loading' />
  );

export default Loader;